import { Component, ViewChild } from "@angular/core";
import { KpiProductHierarchyMasterComponent } from "./kpiproducthierarchy-master.component";
import { KpiProductHierarchyMappingComponent } from "./kpiproducthierarchy-mapping.component";
import { MatTabsModule } from '@angular/material/tabs';

@Component({
    selector: "kpiproducthierarchy",
    standalone: true,
    imports: [
        MatTabsModule,
        KpiProductHierarchyMasterComponent,
        KpiProductHierarchyMappingComponent
    ],
    templateUrl: './kpiproducthierarchy.component.html',
    styleUrls: ['../../style/container-tab-list.component.less']
})

export class KpiProductHierarchyComponent {

    @ViewChild(KpiProductHierarchyMasterComponent, { static: false }) masterComponent!: KpiProductHierarchyMasterComponent;

    constructor() {

    }

    getProducts() {
        if (this.masterComponent) {
            this.masterComponent.getProducts();
        }
    }
}